export { default as TimeLine1 } from './TimeLine1';
export { default as TimeLine2 } from './TimeLine2';
export { default as TimeLine3 } from './TimeLine3';

export { default as EnergyIcon } from './EnergyIcon';
export { default as RightIcon } from './RightIcon';
export { default as WinnerLeft } from './WinnerLeft';
export { default as WinnerRight } from './WinnerRight';

export { default as TaskIcon1 } from './TaskIcon1';
export { default as TaskIcon2 } from './TaskIcon2';
export { default as TaskIcon3 } from './TaskIcon3';
export { default as TaskIcon4 } from './TaskIcon4';
export { default as TaskIcon5 } from './TaskIcon5';
export { default as TaskIcon6 } from './TaskIcon6';
export { default as QuestionIcon } from './QuestionIcon';
